export enum IconType {
    Play = 'play',
    Pause = 'pause',
    SkipBackward = 'skip-backward',
    SkipForward = 'skip-forward',
    VolumeDefault = 'volume-default',
    VolumeFull = 'volume-full',
    VolumeHalf = 'volume-half',
    VolumeNoSound = 'volume-no-sound',
    VolumeMute = 'volume-mute',
    Series = 'series',
    Tracks = 'tracks',
    Help = 'help',
    Settings = 'settings',
    Close = 'close',
    Sharing = 'sharing',
    Streaming = 'streaming',
    Check = 'check',
    Rate = 'rate',
    Arrow = 'arrow',
    BackArrow = 'back-arrow',
    Module = 'module',
    ModuleStreaming = 'module-streaming',
    Station = 'station',
    StationStreaming = 'station-streaming',
    TV = 'tv',
    Retry = 'retry',
    Back = 'back',
    Next = 'next',
    Expand = 'expand',
    Arrows = 'arrows',
    Empty = 'empty',
    ChannelProgram = 'channel-program',
    SubtitlesSize = 'subtitles-size',
    SubtitlesSettingsSize = 'subtitles-settings-size',
}

export enum IconSize {
    Control = 'control',
    LargeControl = 'largeControl',
    Indicator = 'indicator',
    Option = 'option',
    Device = 'device',
    Skip = 'skip',
    Expand = 'expand',
    SubtitlesSettingsSize = 'subtitlesSettingsSize',
    SubtitlesSizeTracks = 'subtitlesSizeTracks',
    SkipPlayerControl = 'skipPlayerControl',
}

export interface IconProps {
    type: IconType;
    size: IconSize;
    position?: 'absolute' | 'relative';
    className?: string;
}
